import React from 'react'
import './style.css'
import DownloadButtons from '../downloadButtons/DownloadButtons'

const ContactForm = () => {
    return (
        <>
            <div className="contact-form-box">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <h1 className="home-main-heading">Contact Us</h1>
                            <h3 className='sub-heading'>I-Sit Corporation</h3>
                            <p className='common-text text-align-contact'><i className="fa-solid fa-envelope mail-icon"></i> lorem@lorem.com</p>

                            <DownloadButtons />
                        </div>

                        <div className="col-md-6">
                            <form action="" className="contact-form">
                                <h1 className="home-main-heading text-center mb-4">Get in touch</h1>

                                <div className="mb-3 custom-input-box">
                                    <input type="text" className="form-control" placeholder="Full Name" />
                                </div>

                                <div action className="form-box-inputs custom-input-box">
                                    <input type="text" defaultValue={+1} className="phone-code" />
                                    <input type="number" placeholder="Phone Number" className="phone-number" />
                                </div>

                                <div className="mb-3 custom-input-box">
                                    <input type="email" className="form-control" placeholder="Email Address" />
                                </div>

                                <div className="mb-3 custom-input-box">
                                    <input type="text" className="form-control" placeholder="Your Message" />
                                </div>

                                <div className="submit-btn-form">
                                    <button type="submit" className="btn btn-primary">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactForm